const ARRAY_SEGMENT_SUFFIX = '[]';

const hasNoValue = value => !value;

const isArraySegment = segment => segment.endsWith(ARRAY_SEGMENT_SUFFIX);

const arrayKeyOf = segment => segment.slice(0, -ARRAY_SEGMENT_SUFFIX.length);

const isSegmentPathMissing = (segments, container) => {
  if (container === null || container === undefined) return true;

  const [segment, ...remainingSegments] = segments;

  if (isArraySegment(segment)) {
    const elements = container[arrayKeyOf(segment)];
    if (!Array.isArray(elements)) return true;
    if (elements.length === 0) return false;
    if (remainingSegments.length === 0) return elements.some(hasNoValue);
    return elements.some(element => isSegmentPathMissing(remainingSegments, element));
  }

  if (remainingSegments.length === 0) return hasNoValue(container[segment]);

  return isSegmentPathMissing(remainingSegments, container[segment]);
};

/**
 * Resolves each required field path against a request payload and returns the paths
 * whose value is missing. Empty string counts as missing, matching the original
 * top-level check this was extracted from.
 *
 * Supported path forms:
 *   'pricingKey'                  flat, top level
 *   'product.price.pricingKey'    dotted, through nested objects
 *   'packages[].pricingKey'       every element of an array must carry a value
 *
 * Pure: never throws and never logs. Callers decide how to fail.
 *
 * @param {string[]} fields
 * @param {object} values
 * @returns {string[]} the subset of `fields` whose value is missing
 */
export const findMissingRequiredFields = (fields, values) => {
  if (!Array.isArray(fields)) return [];

  return fields.filter(path => isSegmentPathMissing(String(path).split('.'), values));
};
